(function () {
  if (window.__imageParallax) return;
  window.__imageParallax = true;

  var shifts = [];
  var ticking = false;
  var reduce = false;
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var resizeObserver = null;

  function prefersReducedMotion() {
    return motionQuery.matches;
  }

  function amountOf(shift) {
    var root = shift.closest('[data-image-parallax]');
    if (!root) return 0;
    var raw = parseFloat(root.getAttribute('data-parallax'));
    if (!isFinite(raw)) return 0;
    return raw / 100;
  }

  function axisOf(root, name) {
    var raw = parseFloat(root.getAttribute(name));
    if (!isFinite(raw)) return 0;
    if (raw < -100) return -1;
    if (raw > 100) return 1;
    return raw / 100;
  }

  function collect() {
    if (resizeObserver) {
      resizeObserver.disconnect();
    }
    shifts = Array.prototype.slice.call(document.querySelectorAll('[data-image-parallax-shift]'));
    if (resizeObserver) {
      for (var i = 0; i < shifts.length; i++) {
        var frame = shifts[i].parentElement;
        if (frame) resizeObserver.observe(frame);
      }
    }
  }

  function update() {
    ticking = false;
    if (reduce) return;

    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < shifts.length; i++) {
      var shift = shifts[i];
      var extra = amountOf(shift);
      if (!extra) {
        shift.style.transform = '';
        continue;
      }

      var root = shift.closest('[data-image-parallax]');
      var frame = shift.parentElement;
      if (!root || !frame) continue;

      var rect = frame.getBoundingClientRect();
      if (rect.height < 1) continue;

      var travel = vh + rect.height;
      if (travel < 1) continue;

      var progress = (vh - rect.top) / travel;
      if (progress < 0 || progress > 1) continue;

      var half = rect.height * Math.abs(extra);
      var py = axisOf(root, 'data-parallax-y');
      var t = (progress - 0.5) * 2;
      var y = extra < 0
        ? (t < 0 ? t * half * (1 + py) : t * half * (1 - py))
        : (t < 0 ? t * half * (1 - py) : t * half * (1 + py));
      shift.style.transform = 'translate3d(0,' + y + 'px,0)';
    }
  }

  function onScroll() {
    if (ticking || reduce) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function refresh() {
    reduce = prefersReducedMotion();
    collect();
    if (reduce) {
      shifts.forEach(function (el) {
        el.style.transform = '';
      });
      return;
    }
    update();
  }

  if (typeof ResizeObserver === 'function') {
    resizeObserver = new ResizeObserver(onScroll);
  }

  window.addEventListener('scroll', onScroll, { passive: true, capture: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', refresh);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('scroll', onScroll, { passive: true });
    window.visualViewport.addEventListener('resize', refresh);
  }
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  document.addEventListener('shopify:section:reorder', refresh);

  if (motionQuery.addEventListener) {
    motionQuery.addEventListener('change', refresh);
  } else if (motionQuery.addListener) {
    motionQuery.addListener(refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
